import * as React from "react";
import { connect } from "react-redux";
import { fetchUsers, FetchUsers } from "../../resources/user/user.actions";
import { getUsers } from "../../resources/user/user.selectors";
import { IUserList } from "../../resources/user/types";
import { IStore } from "../../resources/types";
import Search from "../../components/search";

import User from "./user";

import styles from "./home.module.css";

interface IProps {
  users: IUserList[];
  fetchUsers: FetchUsers;
}

function Home({ users, fetchUsers }: IProps) {
  React.useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const onSearch = (search?: string) => fetchUsers({ search });

  return (
    <>
      <div className={styles.head}>
        <Search onSearch={onSearch} />
      </div>
      <div className={styles.list}>
        {users.map(user => (
          <User key={user._id} user={user} />
        ))}
      </div>
    </>
  );
}

export default connect(
  (state: IStore) => ({
    users: getUsers(state)
  }),
  {
    fetchUsers
  }
)(Home);
